import { getYear, isToday, isYesterday } from 'date-fns';
export const backfillWithTime = dateString => {
  const dateRegex = /^\d{4}-\d{2}-\d{2}/;
  return dateRegex.test(dateString) && dateString.indexOf(':') === -1 ? `${dateString} 00:00:00` : dateString;
};
const formatDate = (value, locale, options) => {
  return Intl.DateTimeFormat(locale, options).format(value);
};
const getShortDate = (date, locale) => formatDate(date, locale, {
  month: 'short',
  day: 'numeric'
});
const getShortDateWithYear = (date, locale) => formatDate(date, locale, {
  month: 'short',
  day: 'numeric',
  year: 'numeric'
});
export const getPeriodString = (period, locale, todayPreset, yesterdayPreset) => {
  if (period.endDate) {
    const showToday = todayPreset && isToday(period.endDate);
    const showYesterday = yesterdayPreset && isYesterday(period.endDate);
    const spaceBetweeDates = locale === 'pt' ? '' : '- ';
    if (getYear(period.startDate) !== getYear(period.endDate)) {
      return `${getShortDateWithYear(period.startDate, locale)} ${spaceBetweeDates}${showToday ? todayPreset : showYesterday ? yesterdayPreset : getShortDateWithYear(period.endDate, locale)}`;
    }
    if (locale === 'ko') {
      return `${getShortDateWithYear(period.startDate, locale)} ${spaceBetweeDates}${showToday ? todayPreset : showYesterday ? yesterdayPreset : getShortDate(period.endDate, locale)}`;
    }
    return `${getShortDate(period.startDate, locale)} ${spaceBetweeDates}${showToday ? todayPreset : showYesterday ? yesterdayPreset : getShortDateWithYear(period.endDate, locale)}`;
  }
  const showStartToday = todayPreset && isToday(period.startDate);
  const showStartYesterday = yesterdayPreset && isYesterday(period.startDate);
  return showStartToday ? todayPreset : showStartYesterday ? yesterdayPreset : `${getShortDateWithYear(period.startDate, locale)}`;
};
//# sourceMappingURL=utils.js.map